module.exports = __webpack_public_path__ + "img/manage-folder-icon.bba5c1c2.svg";